import ChatHeaderPersona from './ChatHeaderPersona';
import { getUnreadMessageCountForOneChat } from '../chatManager/chatFilters';
import ChatState from '../store/schema/ChatState';
import type ChatViewState from '../store/schema/ChatViewState';
import { observer } from 'mobx-react-lite';
import { IconButton } from '@fluentui/react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';

const styles = require('./ChatHeader.scss');

export interface ChatHeaderProps {
    linkedChatViewState: ChatViewState;
    onClickHeader: () => void;
    onClickClose: () => void;
}

const ChatHeader = observer(function ChatHeader(props: ChatHeaderProps) {
    const { linkedChatViewState, onClickHeader, onClickClose } = props;
    const { participants, state } = linkedChatViewState;
    const unreadCount = getUnreadMessageCountForOneChat(linkedChatViewState);

    const onClickCloseButton = React.useCallback(
        (e: React.MouseEvent<unknown>) => {
            e.stopPropagation();
            onClickClose();
        },
        [onClickClose]
    );

    const onClickMinimizeButton = React.useCallback(
        (e: React.MouseEvent<unknown>) => {
            e.stopPropagation();
            onClickHeader();
        },
        [onClickHeader]
    );

    return (
        participants &&
        participants.length > 0 && (
            <div onClick={onClickHeader} className={styles.header}>
                <div className={styles.personas}>
                    <ChatHeaderPersona linkedChatViewState={linkedChatViewState} />
                </div>
                {state != ChatState.Normal && unreadCount > 0 && (
                    <div className={styles.unreadCount}>{unreadCount}</div>
                )}
                <IconButton
                    iconProps={{
                        iconName: ControlIcons.ChromeMinimize,
                        styles: {
                            root: styles.iconNoMargin,
                        },
                    }}
                    onClick={onClickMinimizeButton}
                />
                <IconButton
                    iconProps={{
                        iconName: ControlIcons.ChromeClose,
                        styles: {
                            root: styles.iconNoMargin,
                        },
                    }}
                    onClick={onClickCloseButton}
                />
            </div>
        )
    );
});

export default ChatHeader;
